import { TeChip, TeContainerSlim } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { border } from '../../../providers/theme/theme.index';
import { DivisionScope } from '../../../hooks/queries/useDivisionRollup';

export interface DivisionQuickFilterProps {
  scope: DivisionScope;
  onChange: (scope: DivisionScope) => void;
}

/**
 * Quick filter shared by Customers (02) and Invites (03): All / Organization
 * / Division (PRD D6) as single-select chips, "All" set apart by a divider
 * (Figma 6030:24276). Only rendered by the page when the active Organization
 * has Divisions.
 */
export default function DivisionQuickFilter({ scope, onChange }: DivisionQuickFilterProps) {
  const { t } = useTranslation();

  return (
    <TeContainerSlim alignItems="center" gap="xs">
      <TeChip
        text={t('customersTable.quickFilterAll')}
        toggled={scope === 'currentAndChildren'}
        aria-pressed={scope === 'currentAndChildren'}
        teclick={() => onChange('currentAndChildren')}
      />
      <Divider />
      <TeChip
        text={t('customersTable.quickFilterOrganization')}
        toggled={scope === 'current'}
        aria-pressed={scope === 'current'}
        teclick={() => onChange('current')}
      />
      <TeChip
        text={t('customersTable.quickFilterDivision')}
        toggled={scope === 'children'}
        aria-pressed={scope === 'children'}
        teclick={() => onChange('children')}
      />
    </TeContainerSlim>
  );
}

const Divider = styled.div`
  height: 16px;
  width: 1px;
  background: ${border.primary};
`;
